import React, { lazy, Suspense } from 'react';
import LoadingIndicator from '@wix/da-ds/pkg/LoadingIndicator';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import { useIsMounted } from '@wix/da-hooks/pkg/useIsMounted';
import useI18next from '../../hooks/useI18next';
import retry from '../utils/chunkRetry';
const LoadableRedux = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "editor_v3", webpackPrefetch: true */ '../../redux/EditorModuleLoader')));
const I18NextLoader = ()=>{
    useI18next();
    return null;
};
/**
 * This is a wrapper that should be used in your preset
 */ const EditorLoadableWrapper = ({ children, fallback })=>{
    const isMounted = useIsMounted();
    if (!isMounted) {
        return null; // never SSR
    }
    return /*#__PURE__*/ React.createElement(ErrorBoundary, {
        debugComponent: "EditorLoadableWrapper"
    }, /*#__PURE__*/ React.createElement(Suspense, {
        fallback: fallback !== null && fallback !== void 0 ? fallback : /*#__PURE__*/ React.createElement(LoadingIndicator, {
            view: 'llama'
        })
    }, /*#__PURE__*/ React.createElement(I18NextLoader, null), /*#__PURE__*/ React.createElement(LoadableRedux, null), children));
};
EditorLoadableWrapper.displayName = 'EditorLoadableWrapper';
export default EditorLoadableWrapper;

//# sourceMappingURL=EditorLoadableWrapper.js.map